module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-47.2d137f2e.png";